import { assets, benefits } from "../data/siteData";

export default function BenefitsSection() {
  return (
    <section className="section benefits-section" aria-labelledby="gain-title">
      <div className="section-heading">
        <p className="eyebrow">What you gain</p>
        <h2 id="gain-title">Focused direction for serious gospel musicians.</h2>
      </div>

      <ul className="benefits-list">
        {benefits.map((item) => (
          <li key={item}>
            <img src={assets.checkmarkIcon} alt="" aria-hidden="true" />
            <p>{item}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
